import { PersonJobType } from '@api';

export const getAllJobs = (unconfirmedShows: PersonJobType[]): string[] => {
  return unconfirmedShows.flatMap((show) =>
    Object.values(show.jobs).map((job) => job?.id ?? '')
  );
};
